module.exports = __webpack_public_path__ + "static/media/5_19.409fa40b.png";